module.exports = __webpack_public_path__ + "static/media/OutliersQ5_4.e3be87fd.svg";